module.exports = __webpack_public_path__ + "img/tab_article_pre@2x.1d0bc8e3.png";